<template>
  <div id="progress-loading-excel">
    <div class="img-loading">
      <img :src="IconCSVActive" width="60" height="60" />
    </div>

    <div class="progress-layout mt-1">
      <b-progress :max="formData.max" height="1.3rem">
        <b-progress-bar :value="formData.value" class="color-progress">
        </b-progress-bar>
      </b-progress>
    </div>
    <div class="text-progress">
      กำลังอัปโหลดไฟล์ กรุณารอสักครู่... {{ formData.value }}%
    </div>
  </div>
</template>

<script>
import IconCSVActive from "@/assets/images/pages/upload-file/IconCSVActive.png";
import {
  reactive,
  onBeforeMount,
  watch,
  getCurrentInstance,
  computed,
} from "@vue/composition-api";

export default {
  components: {},
  props: {
    formData: { type: Object, default: null },
    isUpload: { type: Boolean, default: false },
  },
  setup(props, { emit }) {
    const vm = getCurrentInstance().proxy;

    const formProgress = reactive({
      value: 0,
      max: 100,
    });

    const initData = () => {
      return new Promise((resolve, reject) => {
        if (props.formData) {
          formProgress.value = props.formData.value;
          formProgress.max = props.formData.max;
        }
        resolve();
      });
    };

    const startTimer = () => {
      let timer = setInterval(() => {
        formProgress.value += 1;
        if (formProgress.value == formProgress.max) {
          clearInterval(timer);
        }
      }, 100);
    };

    onBeforeMount(() => {
      initData().then(() => {
        startTimer();
      });
    });

    watch(
      props,
      () => {
        if (props.isUpload) {
          initData().then(() => {
            startTimer();
          });
        }
      },
      { deep: true }
    );

    watch(
      formProgress,
      () => {
        vm.$nextTick(() => {
          emit("onUpdateProgress", formProgress.value);
        });
      },
      { deep: true }
    );

    return { IconCSVActive };
  },
};
</script>

<style scoped>
.img-loading {
  display: flex;
  justify-content: center;
}

#progress-loading-excel .progress-bar {
  background-color: #0068ff !important;
  border-radius: 7px !important ;
}

#progress-loading-excel .progress {
  background-color: #ffffff;
  border: 1px solid rgba(0, 104, 240, 0.5);
}

.progress-layout {
  margin: auto;
  width: 423px;
}

.text-progress {
  display: flex;
  justify-content: center;
  color: #0068ff;
}
</style>
